import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Link } from 'react-router-dom'
import InputFieldUnlabelled from './input-field-unlabelled'
import CtaButton from '../buttons/cta-button'
//import CtaButtonSecondary from '../buttons/cta-button-secondary'
import NormalText from '../texts/normal-text'
import Notification from '../notifications/notification'
import CheckItem from './check-item'
import withReduxForm from './withReduxFormField'

const Input = withReduxForm(InputFieldUnlabelled)
const Check = withReduxForm(CheckItem)

const RegisterForm = props => {
  const { submitFailed, handleSubmit, error, translations } = props
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name='email'
        type='email'
        id='email'
        component={Input}
        label={translations.emailLabel}
        placeholder={translations.emailPlaceholder}
        theme='dark-theme'
        iconName='email'
        autoFocus={true}
      />
      <Field
        name='name'
        component={Input}
        id='name'
        label={translations.nameLabel}
        placeholder={translations.namePlaceholder}
        theme='dark-theme'
        iconName='user-profile'
      />
      <Field
        name='lastName'
        id='last-name'
        component={Input}
        label={translations.lastNameLabel}
        placeholder={translations.lastNamePlaceholder}
        theme='dark-theme'
        iconName='user-profile'
      />

      <Field
        name='password'
        type='password'
        id='password'
        component={Input}
        label={translations.passwordLabel}
        placeholder={translations.passwordPlaceholder}
        theme='dark-theme'
        iconName='password'
      />
      <Field
        name='confirmPassword'
        type='password'
        id='confirm-password'
        component={Input}
        label={translations.confirmPasswordLabel}
        placeholder={translations.confirmPasswordPlaceholder}
        theme='dark-theme'
        iconName='password'
      />
      {submitFailed &&
        error && (
          <Notification status='error' iconName='warning' hasIcon>
            {error}
          </Notification>
        )}

      <Field
        name='acceptTerms'
        theme='dark-theme'
        id='checkbox_option_01'
        label={translations.haveReadConditionsText}
        component={Check}
      />
      <div className='form-field'>
        <NormalText>
          <a href='/terms' rel='no opener' target='new' className='single-link'>
            Read terms of service
          </a>
        </NormalText>
      </div>
      <div className='form-field'>
        <CtaButton
          text={translations.createAccountButton}
          onSubmit={handleSubmit}
        />
      </div>
      {/*
      <div className='top-space bottom-space'>
        <CtaButtonSecondary
          hasIcon
          iconName='social-facebook'
          text={translations.faceBookSignInButton}
        />
      </div>
      */}
      <NormalText>
        {translations.haveAccountText}
        <Link to='/login' className='single-link'>
          {' ' + translations.signIn}
        </Link>
      </NormalText>
    </form>
  )
}

RegisterForm.defaultProps = {
  handleSubmit: () => {},
  translations: {
    emailLabel: 'email label',
    emailPlaceholder: 'email placeholder',
    nameLabel: 'name label',
    namePlaceholder: 'name placeholder',
    lastNameLabel: 'last name label',
    lastNamePlaceholder: 'last name placeholder',
    passwordLabel: 'password label',
    passwordPlaceholder: 'password placeholder',
    confirmPasswordLabel: 'confirm password label',
    confirmPasswordPlaceholder: 'confirm password placeholder',
    haveReadConditionsText: 'have read conditions text',
    createAccountButton: 'create account button',
    faceBookSignInButton: 'facebook button',
    haveAccountText: 'have account text',
    signIn: 'sign in button'
  }
}

RegisterForm.PropTypes = {
  handleSubmit: PropTypes.function,
  submitFailed: PropTypes.bool,
  error: PropTypes.string,
  translations: PropTypes.shape({
    emailLabel: PropTypes.string.isRequired,
    emailPlaceholder: PropTypes.string.isRequired,
    nameLabel: PropTypes.string.isRequired,
    namePlaceholder: PropTypes.string.isRequired,
    lastNameLabel: PropTypes.string.isRequired,
    lastNamePlaceholder: PropTypes.string.isRequired,
    passwordLabel: PropTypes.string.isRequired,
    passwordPlaceholder: PropTypes.string.isRequired,
    confirmPasswordLabel: PropTypes.string.isRequired,
    confirmPasswordPlaceholder: PropTypes.string.isRequired,
    haveReadConditionsText: PropTypes.string.isRequired,
    createAccountButton: PropTypes.string.isRequired,
    faceBookSignInButton: PropTypes.string.isRequired,
    haveAccountText: PropTypes.string.isRequired,
    signIn: PropTypes.string.isRequired
  }).isRequired
}

export default RegisterForm



// WEBPACK FOOTER //
// ./src/ui/forms/register-form.js